export default {
    svg(svgImg)
    {
        const url = require("@/assets/svg/" + svgImg);
        return url;
    },    
    flag(code){
        const url = require("@/assets/svg/flags/" + code+".svg");
        return url;
    },
    card(key, deck_setting){
        deck_setting = deck_setting ?? "Classic"
        const url = require("@/assets/decks/" + deck_setting + "/" + key + ".svg");
        return url;
    }
};
